import { setItem } from '@Utils/LocalStorage';
import { PROJECTS_STATE_LOCAL_STORAGE_KEY, PROJECTS_REDUCER_NAME } from './Constants';

export const saveProjectsInLocalStorage = store => next => action => {
  const { type } = action;
  const result = next(action);

  if (type.startsWith(PROJECTS_REDUCER_NAME)) {
    setItem(PROJECTS_STATE_LOCAL_STORAGE_KEY, store.getState()[PROJECTS_REDUCER_NAME]);
  }

  return result;
};
